/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForGitHubAppProtocol extends models.ServiceAccountCredentialsBaseForGitHub {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForGitHubAppProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForGitHubAppProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForGitHubAppProtocol>): ServiceAccountCredentialsForGitHubAppProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForGitHubAppProtocol(), model);
        ServiceAccountCredentialsForGitHubAppProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForGitHubAppProtocol>): ServiceAccountCredentialsForGitHubAppProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForGitHubAppProtocol.newInstance(<ServiceAccountCredentialsForGitHubAppProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForGitHubAppProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForGitHubAppProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForGitHubAppProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForGitHub.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForGitHubAppProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Application Id. This is a required Field.
     */
    application_id: string;

    /**
     * Private Key. This is a required Field
     */
    private_key: string;

    /**
     * Installation Id. This is a required Field
     */
    installation_id: string;

}
